import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

import useAlerts from '../../../hooks/order/useAlerts';
import globalTranslations from '../../../i18n/globalTranslations';
import { modelOf } from '../../../prop-types';
import CartStore from '../../../store/CartStore';
import UIStore from '../../../store/UIStore';
import ProductTypeClass from '../../../types/ProductTypeClass';
import CartProductAlerts from '../CartProductAlerts';
import CartProductRow from '../CartProductRow';

const CartProductListing = ({
  cartStore,
  uiStore,
  productListHeight,
  activeCoupons,
  showProductListingColumn,
  withTax,
}) => {
  const { cart } = cartStore;

  const { renderErrorAlerts } = useAlerts({
    errorAlerts: cart?.commonAlerts.errors,
  });

  const getFilteredProducts = () => {
    let filteredProducts = [];

    filteredProducts = cart.products.filter(
      (cartProduct) => cartProduct.type !== ProductTypeClass.DISCOUNT
    );

    return filteredProducts;
  };

  return (
    <Col
      xs="12"
      md="6"
      className={classNames(
        'CartProductListing',
        'CartModal__column CartModal__left-column',
        {
          'CartModal__left-column-with-coupons-compensation': activeCoupons,
          'order-2': showProductListingColumn && uiStore.isMobile,
        }
      )}
    >
      <h4 className="CartModal__title">
        <FormattedMessage {...globalTranslations.productsTitle} />
      </h4>
      <div className="CartModal__column-inner--small-padding">
        {cart.commonAlerts.errors.length > 0 && (
          <Row>
            <CartProductAlerts alerts={renderErrorAlerts()} />
          </Row>
        )}
        <div
          className="CartModal__product-list--with-images"
          style={{ maxHeight: productListHeight }}
        >
          {getFilteredProducts().map((product, index) => (
            <CartProductRow
              key={`${product.id}_${index}`}
              product={product}
              withTax={withTax}
            />
          ))}
        </div>
      </div>
    </Col>
  );
};

CartProductListing.propTypes = {
  cartStore: modelOf(CartStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  productListHeight: PropTypes.string,
  activeCoupons: PropTypes.bool,
  showProductListingColumn: PropTypes.bool,
};

export default inject('cartStore', 'uiStore')(observer(CartProductListing));
